import styled from 'styled-components'

const StyledAccountSettings = styled.div`
  .account-settings-header-container {
    background-color: ${({ theme }) => theme.colors.gray[100]};

    .account-settings-header {
      max-width: 600px;
      width: 100%;
      margin: 0 auto;
      padding: 20px;

      h1 {
        margin: 0;
        font-size: 24px;
        font-weight: 600;
        color: ${({ theme }) => theme.colors.gray[800]};
      }

      h2 {
        margin: 8px 0 0 0;
        font-size: 16px;
        font-weight: 400;
        color: ${({ theme }) => theme.colors.gray[500]};
      }
    }
  }

  .account-settings-content {
    max-width: 600px;
    width: 100%;
    margin: 0 auto;
    padding: 20px;

    .account-settings-group {
      &:not(:last-child) {
        padding-bottom: 20px;
        margin-bottom: 20px;
        border-bottom: 1px solid ${({ theme }) => theme.colors.gray[200]};
      }

      .account-settings-group-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 16px;

        .account-settings-group-header-actions {
          display: flex;
          align-items: center;

          button:not(:last-child) {
            margin-right: 10px;
          }
        }

        h3 {
          margin: 0;
          font-size: 20px;
          font-weight: 600;
          color: ${({ theme }) => theme.colors.gray[700]};
        }

        button {
          height: 34px;
          display: flex;
          align-items: center;
          border: none;
          transition: 0.2s;
          border-radius: 6px;
          padding: 0 10px;
          font-weight: 600;
          user-select: none;
          background-color: ${({ theme }) => theme.colors.gray[100]};
          color: ${({ theme }) => theme.colors.gray[600]};

          span {
            position: relative;
            top: 1px;
          }

          svg:not(.spinner-icon) {
            height: 18px;
            margin-right: 8px;
          }

          &:hover {
            cursor: pointer;
            background-color: ${({ theme }) => theme.colors.gray[200]};
          }

          &.primary-btn {
            color: ${({ theme }) => theme.colors.background};
            background-color: ${({ theme }) => theme.colors.green[500]};

            &:hover {
              background-color: ${({ theme }) => theme.colors.green[600]};
            }
          }

          &:disabled {
            background-color: ${({ theme }) => theme.colors.gray[100]};
            color: ${({ theme }) => theme.colors.gray[400]};

            &:hover {
              cursor: not-allowed;
              background-color: ${({ theme }) => theme.colors.gray[100]};
            }
          }
        }
      }
    }
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.s}px) {
    .account-settings-header-container {
      .account-settings-header {
        padding: 40px 20px;
      }
    }

    .account-settings-content {
      padding: 40px 20px;

      .account-settings-group {
        &:not(:last-child) {
          padding-bottom: 40px;
          margin-bottom: 40px;
        }
      }
    }
  }
`

export default StyledAccountSettings
